import React from "react";

export const LeftLarge = props => (
  <svg
    width="20px"
    height="11px"
    viewBox="0 0 20 11"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs />
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-502.000000, -537.000000)" fill="white">
        <g transform="translate(208.000000, 524.000000)">
          <g>
            <g>
              <g transform="translate(304.500000, 18.500000) rotate(-90.000000) translate(-304.500000, -18.500000) translate(299.000000, 8.000000)">
                <g>
                  <path d="M2.421,10 L6.498,5.923 L6.498,5.923 L10.707,1.714 C11.098,1.323 11.098,0.69 10.707,0.3 L10.701,0.293 C10.31,-0.098 9.677,-0.098 9.286,0.293 L1,8.579 L1,8.579 L1,8.579 L0.356,9.224 L0.372,9.24 C0.15,9.423 0,9.69 0,10 C0,10.276 0.112,10.526 0.293,10.707 L0.29,10.71 L1,11.421 L4.434,14.855 L9.286,19.707 C9.677,20.098 10.31,20.098 10.701,19.707 L10.707,19.7 C11.098,19.31 11.098,18.677 10.707,18.286 L2.421,10 Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
